export default (value, pattern) => {
    const v = value.toString().replace(/\D/g,"")

    if(pattern === 'brl') {
        return number(v, ',', '.')
    }

    if(pattern === 'number') {
        return v
    }

    
    let ic = 0
    let rv = ''
    
    for (let i = 0; i < pattern.length; ++i) {
        const c = v.charAt(ic)
        const m = pattern.charAt(i)

        if(c === '') break
        
        if(m !== '#') {
            rv += m
        } else {          
            rv += c
            ic++
        }
    }

    return rv
}

export const number = (v, decimal = '.', hundred = ',') => {
    v = v.replace(/\D/g,"")
    v = v.replace(/(\d{2})$/,`${decimal}$1`)

    v = v.replace(/(\d+)(\d{3},\d{2})$/g,`$1${hundred}$2`)
    
    var qtdLoop = (v.length-3)/3;
    var count = 0;
    while (qtdLoop > count) {
        count++;
        v = v.replace(/(\d+)(\d{3}.*)/,`$1${hundred}$2`)
    }
    
    v = v.replace(/^(0)(\d)/g,"$2")
                
    return v
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Form/mask.js